import { MultipleQuestionDefinitionDto, UserQuizQuestionAnswerDto } from '@/api/generated';
import { DomPurifyConfig } from '@/config/DomPurify.config.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import DOMPurify from 'dompurify';
import parseHtml from 'html-react-parser';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

interface MultipleQuestionProps {
  disabled: boolean;
  onAnswerSelected: (questionDefinition: UserQuizQuestionAnswerDto) => void;
  questionDefinition: {
    discriminatorType: 'MULTIPLE';
  } & MultipleQuestionDefinitionDto;
}

const MultipleQuestionForm: React.FC<MultipleQuestionProps> = ({
  disabled,
  onAnswerSelected,
  questionDefinition,
}) => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions');
  const { answerDefinition, maxSelectedAnswers = 3, question } = questionDefinition;
  const [formData, setFormData] = useState<number[]>([]);

  const handleCheck = (answerIndex: number) => () =>
    setFormData(state =>
      state.includes(answerIndex)
        ? state.filter(item => item !== answerIndex)
        : [...state, answerIndex],
    );

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onAnswerSelected({
      answerIndices: formData,
      discriminatorType: questionDefinition.discriminatorType,
    });
  };

  return (
    <div>
      <Form className="flex flex-column gap-l" onSubmit={handleSubmit}>
        <p className="lead fw-bold">{parseHtml(DOMPurify.sanitize(question, DomPurifyConfig))}</p>
        <Form.Group>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-l">
            {answerDefinition.options.map(option => (
              <Form.Check
                checked={formData.includes(option.index)}
                className="mb-2 lead"
                disabled={
                  (!formData.includes(option.index) && formData.length === maxSelectedAnswers) ||
                  disabled
                }
                id={option.index.toString()}
                key={option.index}
                label={option.answer}
                onChange={handleCheck(option.index)}
                type="checkbox"
                value={option.index.toString()}
              />
            ))}
          </div>
        </Form.Group>
        <Button
          className="px-sm-5 align-self-sm-start"
          disabled={!formData.length || disabled}
          type="submit"
        >
          {t('buttons.next')}
        </Button>
      </Form>
    </div>
  );
};

export default MultipleQuestionForm;
